import { Typography } from '@mui/material';
import { Wrapper } from '@styles/CommonStyles';
import { TItleScanTabs } from './tabs/TItleScanTabs';

const TitleScanConfig = () => {
  return (
	<Wrapper>
		<Typography variant='h3' mt='16px'>Title Scan Configuration</Typography>
		<TItleScanTabs />
	</Wrapper>
  );
};

export default TitleScanConfig;
